import React, { useEffect, useRef } from "react";
import { useState } from "react";
import ColorPicker from "react-best-gradient-color-picker";

import { faPencil, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadAppText,
  downloadAppColor,
  downloadAppSize,
} from "../../../../slice/Features/downloadApps";
import { currentFeature } from "../../../../slice/features";

import axios from "axios";
import { toast } from "react-toastify";
import lang from "../../../../assets/lang/icons.json";
import BodyLoading from "../../Loading/BodyLoading";
import Pro from "../../Pro/Pro";
import style from "./DownloadApps.module.css";

const DownLoadApps = () => {
  const dispatch = useDispatch();
  const isAuth = localStorage.getItem("auth_token") ? true : false;

  const downloadApp = useSelector((state) => state.downloadApp);

  const [bodyLoading, setBodyLoading] = useState(false);

  const [Text, setText] = useState({
    Title: "",
    GooglePlay: "",
    AppStore: "",
  });

  const [Color, setColor] = useState(
    downloadApp.downloadAppColor[0].downloadAppColor
  );
  const [Size, setSize] = useState(
    downloadApp.downloadAppSize[0].downloadAppSize
  );

  const [showColorPicker, setShowColorPicker] = useState(false);

  const CancelFeature = (e) => {
    e.preventDefault();
    dispatch(currentFeature(""));
  };

  const handleInput = (e) => {
    e.preventDefault();

    setText({ ...Text, [e.target.name]: e.target.value });
  };

  const handleNameColor = () => {
    setShowColorPicker(!showColorPicker);
  };

  const saveFeature = async (e) => {
    e.preventDefault();
    dispatch(currentFeature(""));
    try {
      const data = {
        Title: Text.Title,
        GooglePlay: Text.GooglePlay,
        AppStore: Text.AppStore,
        color: Color,
        size: Size,
      };

      const response = await axios.post("/add/download-app", data);
      if (response.data.status === 200) {
        console.log(response.data);
        toast.success(response.data.message, {
          closeOnClick: true,
          theme: "colored",
        });
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resetDisclaimer = async () => {
    if (isAuth) {
      try {
        const response = await axios.post("/reset/download-app");
        if (response.data.status === 200) {
          setText({
            Title: "",
            GooglePlay: "",
            AppStore: "",
          });
          setColor("rgba(0,0,0,100)");
          setSize("1");
          fetch();
          toast.info(response.data.message, {
            closeOnClick: true,
            theme: "colored",
          });
        } else {
          console.log(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const fetch = async () => {
    try {
      const response = await axios.get("/getUser");
      const user = await response.data.user;

      if (user.download_apps_id !== null) {
        const data = {
          Title:
            user.download_apps.title !== null ? user.download_apps.title : "",
          GooglePlay:
            user.download_apps.google_store_url !== null
              ? user.download_apps.google_store_url
              : "",
          AppStore:
            user.download_apps.app_store_url !== null
              ? user.download_apps.app_store_url
              : "",
        };
        dispatch(downloadAppText(data));
        dispatch(downloadAppColor(user.download_apps.color));
        dispatch(downloadAppSize(user.download_apps.size));
        setText(data);
        setColor(user.download_apps.color);
        setSize(user.download_apps.size);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dispatch(downloadAppText(Text));
    dispatch(downloadAppColor(Color));
    dispatch(downloadAppSize(Size));
  }, [Text, Color, Size, dispatch, isAuth]);

  useEffect(() => {
    if (isAuth) {
      fetch();
    }
  }, []);

  return (
    <div className={`text-start `}>
      <h6>DownLoad Our App</h6>
      {bodyLoading ? <BodyLoading /> : null}
      <div className="" style={{ minHeight: "650px" }}>
        <div className={`${style.Form}`}>
          <span className="w-100 custom-header">Add app title & links</span>

          <div className="d-flex flex-column">
            <div className="mb-3 position-relative">
              <label className="custom-label">Title</label>
              <input
                type="text"
                name="Title"
                autoComplete="off"
                value={Text.Title}
                onChange={handleInput}
              ></input>
              <span className={`${style.FormInputIcon}`}>
                <FontAwesomeIcon icon={faPencil} />
              </span>
            </div>

            <div className="mb-3 position-relative">
              <label className="custom-label">Google Play </label>
              <input
                type="text"
                name="GooglePlay"
                autoComplete="off"
                value={Text.GooglePlay}
                onChange={handleInput}
              ></input>
              <span className={`${style.FormInputIcon}`}>
                <FontAwesomeIcon icon={faPencil} />
              </span>
            </div>

            <div className="mb-3 position-relative">
              <label className="custom-label">App Store</label>
              <input
                type="text"
                name="AppStore"
                autoComplete="off"
                value={Text.AppStore}
                onChange={handleInput}
              ></input>
              <span className={`${style.FormInputIcon}`}>
                <FontAwesomeIcon icon={faPencil} />
              </span>
            </div>
          </div>
        </div>

        <div className="d-flex flex-wrap">
          <span className="w-100 custom-header"> Style</span>

          <div className="mb-4 position-relative d-flex align-items-center flex-wrap w-100">
            <div className="w-25">
              <label className="d-block custom-lable "> Font Color</label>
            </div>
            <div className="w-50">
              <button
                className={`${style.customStyColorPicker}`}
                onClick={handleNameColor}
                style={{
                  background: Color,
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                }}
              />
              {showColorPicker ? (
                <ColorPicker
                  className={`${style.customColorPicker} my-2  `}
                  value={Color}
                  onChange={setColor}
                  hideOpacity={true}
                  hideControls={true}
                  hidePresets={true}
                  width={250}
                  height={250}
                />
              ) : null}
            </div>
          </div>

          <div className="mb-4 position-relative d-flex align-items-center flex-wrap w-100">
            <div className="w-25">
              <label className="d-block custom-lable ">Font Size</label>
            </div>
            <div className="w-50">
              <input
                // className={`${style.customStyInput2} `}
                type="range"
                step={1}
                min={0}
                max={2}
                value={Size}
                onChange={(event) => {
                  setSize(Number(event.target.value));
                }}
              />
            </div>
          </div>
        </div>
        {/* {Object.values(Text).every((el) => el !== "") ? ( */}
        {isAuth &&
        (Text.Title !== "" ||
          Text.GooglePlay !== "" ||
          Text.AppStore !== "") ? (
          <div
            className=" py-2 px-3 d-flex flex-wrap"
            style={{ background: "silver" }}
          >
            <button className={`${style.btnReset}`} onClick={resetDisclaimer}>
              <FontAwesomeIcon icon={faTrashAlt} className="me-1" />
              Reset
            </button>
          </div>
        ) : null}
      </div>
      <div className="my-3">
        <button
          className={`btn btn-primary me-2 ${
            Text.Title !== "" || Text.GooglePlay !== "" || Text.AppStore !== ""
              ? ""
              : "disabled"
          }`}
          onClick={saveFeature}
        >
          save
        </button>
        <button className="btn btn-outline-secondary" onClick={CancelFeature}>
          Cancel
        </button>
      </div>
    </div>
  );
};
export default DownLoadApps;
